/* eslint-disable */
import promise, { Promise } from 'Js/api/lib/promisejs';
import * as convert from 'Js/api/lib/convert';

function request(
    type,
    url,
    contentType,
    dataType,
    data,
    settings,
    process,
    customHeaders
) {
    const p = new Promise();
    const headers = Object.assign(
        { 'X-Requested-With': 'XMLHttpRequest' },
        customHeaders
    );
    let parse;
    const resolve = (error, response, req) => {
        if (error) {
            p.done(error, response, req);
        } else {
            const _resolve = () =>
                process
                    ? p.done(false, process(parse(response)), req)
                    : p.done(false, parse(response), req);
            if (__DEVELOPMENT__) {
                _resolve();
            } else {
                try {
                    _resolve();
                } catch (e) {
                     
                    console.warn(e);
                    p.done(true, null, req);
                }
            }
        }
    };

    switch (dataType) {
        case 'json':
            headers.Accept = 'text/plain';
            parse = convert.strToJson;
            break;
        case 'xml':
            headers.Accept = 'Accept: application/xml, text/xml';
            parse = convert.xmlToJson;
            break;
        default:
            parse = (...args) => args[0];
    }
    if (contentType) {
        headers['Content-type'] = contentType;
    }
     
    promise[type](url, data, headers, settings).then(function(
        error,
        response,
        xhrRequest
    ) {
        if (xhrRequest.__CAPTCHA__) {
            document.addEventListener('captcha', e => {
                if (e.detail.status == 'success') {
                    promise[type](url, data, headers, settings).then(resolve);
                } else {
                    p.done(error, response, xhrRequest);
                }
            });
        } else {
            const args = [error, response, xhrRequest];
            resolve.apply(null, [...args]);
        }
    });
    return p;
}

function bindRequest(settings) {     
    return _args => {
        const args = { ..._args, ...settings };
        return request(
            args.type ? args.type.toLowerCase() : 'get',
            args.url,
            args.contentType ? args.contentType : '',
            args.dataType ? args.dataType.toLowerCase() : '',
            args.data,
            args.settings,
            args.process,
            args.headers
        );
    };
}
export default {
    Promise,
    request,
    join: promise.join,
    chain: promise.chain,
    get: bindRequest({ type: 'get' }),
    post: bindRequest({ type: 'post' }),
    put: bindRequest({ type: 'put' }),
    patch: bindRequest({ type: 'patch' }),
    delete: bindRequest({ type: 'delete' })
};
